// A page the Cockpit lists but hasn't built yet: it says so and points to Chat, where LAMP can help.
import { useWords } from "../i18n/words.js";
import { PAGES, type Page } from "./nav.js";

export function Placeholder({ onNavigate }: { onNavigate: (page: Page) => void }) {
  const w = useWords();
  return (
    <section className="placeholder">
      <p>{w.shellSoon}</p>
      <p>
        <a
          href={PAGES.chat.path}
          onClick={(event) => {
            if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            onNavigate("chat");
          }}
        >
          {w.shellOpenChat}
        </a>
      </p>
    </section>
  );
}
